import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/base.scss'
import i18n from "./i18n/index"; // 国际化模块
// import '@/utils/rem.js';
Vue.config.productionTip = false;
// element-ui的国际化
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value),
});

Vue.use(ElementUI)
router.afterEach((to, from) => {
  window.scrollTo(0, 0)
})
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';  // 核心样式
Vue.use(VueAwesomeSwiper);
new Vue({
  router,
  i18n, // 使用国际化
  render: h => h(App)
}).$mount('#app')
